<!--
  新增 / 编辑告警接收人弹窗
  字段同接口：name / chatId / webhookUrl / subscribeTypes（数字数组）/ enable
  编辑时 webhookUrl 留空即保持原值（列表只返回脱敏后的 webhook）
-->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="560px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @closed="handleClosed"
  >
    <div slot="title" class="fd-head">
      <div class="fd-ico">
        <svg
          width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2"
        >
          <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
      </div>
      <div class="fd-title">
        <span>{{ isAdd ? '新增告警接收人' : '编辑接收人' }}</span>
        <span class="fd-pt">{{ isAdd ? 'Novo Destinatário de Alerta' : 'Editar Destinatário' }}</span>
      </div>
    </div>

    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-position="top"
      size="small"
    >
      <el-form-item prop="name">
        <template slot="label">
          <bi-label zh="接收群名称" pt="Nome do Grupo" inline />
        </template>
        <el-input
          v-model="form.name"
          placeholder="例如：税务开票风险预警群 / Ex.: Grupo de Risco Fiscal"
        />
      </el-form-item>

      <!--      <el-form-item prop="chatId">-->
      <!--        <template slot="label">-->
      <!--          <bi-label zh="飞书群 ChatID" pt="ChatID do Grupo Feishu" inline />-->
      <!--        </template>-->
      <!--        <el-input v-model="form.chatId" placeholder="oc_xxx..." />-->
      <!--        <div class="hint">-->
      <!--          飞书群 → 群设置 → 群信息 / Grupo Feishu → Configurações → Informações do Grupo-->
      <!--        </div>-->
      <!--      </el-form-item>-->

      <el-form-item prop="webhookUrl">
        <template slot="label">
          <bi-label zh="机器人 Webhook" pt="Webhook do Bot" inline />
        </template>
        <el-input
          v-model="form.webhookUrl"
          :placeholder="isAdd ? 'https://open.feishu.cn/...' : '留空保持原值 / Deixe vazio para manter o valor atual'"
        />
        <div v-if="!isAdd" class="hint">
          编辑时留空表示保持原 webhook 不变 / Em edição, deixe vazio para manter o webhook atual
        </div>
      </el-form-item>

      <el-form-item>
        <template slot="label">
          <bi-label zh="订阅类型" pt="Tipos Assinados" inline />
        </template>
        <el-checkbox-group v-model="form.subs" class="subs-group">
          <el-checkbox v-for="t in alertTypes" :key="t.value" :label="t.value">
            <span>{{ t.zh }}</span>
            <span class="sub-pt">/ {{ t.pt }}</span>
          </el-checkbox>
        </el-checkbox-group>
        <div class="hint">
          不勾选表示订阅全部告警类型 / Sem seleção = assina todos os tipos de alerta
        </div>
      </el-form-item>

      <el-form-item>
        <template slot="label">
          <bi-label zh="启用" pt="Ativação" inline />
        </template>
        <el-switch v-model="form.enable" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="fd-footer">
      <el-button size="small" @click="innerVisible = false">
        <bi-label zh="取消" pt="Cancelar" inline />
      </el-button>
      <el-button size="small" type="primary" @click="handleSave">
        <bi-label zh="保存" pt="Salvar" inline />
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import BiLabel from './BiLabel';
import { ALERT_TYPE_LABEL } from '../mock';

export default {
  name: 'RecipientDialog',
  components: { BiLabel },
  props: {
    visible: { type: Boolean, default: false },
    // add：新增接收人；edit：编辑接收人
    mode: { type: String, default: 'add' },
    row: { type: Object, default: null }
  },
  data() {
    return {
      // 可订阅的告警类型：1 紧急告警 / 2 恢复通知 / 3 警告通知（静态字典）
      alertTypes: Object.keys(ALERT_TYPE_LABEL).map(k => ({
        value: Number(k),
        zh: ALERT_TYPE_LABEL[k].zh,
        pt: ALERT_TYPE_LABEL[k].pt
      })),
      form: { name: '', chatId: '', webhookUrl: '', subs: [], enable: true },
      rules: {
        name: [{ required: true, message: '名称必填 / Nome obrigatório', trigger: 'blur' }],
        // chatId: [
        //   { required: true, message: 'ChatID 必填 / ChatID obrigatório', trigger: 'blur' },
        //   {
        //     validator: (r, v, cb) => (String(v || '').startsWith('') ? cb() : cb(new Error('需以 oc_ 开头 / Deve começar com oc_'))),
        //     trigger: 'blur'
        //   }
        // ],
        webhookUrl: [
          {
            validator: (r, v, cb) => {
              // 新增必填；编辑留空表示保持原值
              if (!v) return this.isAdd ? cb(new Error('Webhook 必填 / Webhook obrigatório')) : cb();
              return String(v).startsWith('')
                ? cb()
                : cb(new Error('需为飞书机器人地址 / Deve ser um webhook do Feishu'));
            },
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    /** 弹窗显隐：与父组件 visible 双向绑定（支持 v-model / .sync） */
    innerVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    },
    /** 是否新增模式 */
    isAdd() {
      return this.mode === 'add';
    }
  },
  watch: {
    /** 监听显隐：每次打开都重新初始化表单（避免残留上次输入与校验态） */
    visible(v) {
      if (v) this.initForm();
    }
  },
  methods: {
    /** 初始化表单：编辑模式回填当前行（webhook 不回填，接口只给脱敏值） */
    initForm() {
      const r = this.row || {};
      this.form = {
        name: r.name || '',
        chatId: r.chatId || '',
        webhookUrl: '',
        subs: this.parseSubs(r.subscribeTypes),
        enable: r.enable !== 0
      };
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate());
    },
    /** 订阅类型解析：字符串（"[1,2,3]" 或 "1,2,3"）→ 数字数组 */
    parseSubs(v) {
      if (!v) return [];
      if (Array.isArray(v)) return v.map(Number);
      const s = String(v).trim();
      if (!s) return [];
      try {
        const arr = JSON.parse(s);
        if (Array.isArray(arr)) return arr.map(Number);
      } catch (e) {
        // 非 JSON：按逗号分隔再转数字
      }
      return s.split(',').map(x => Number(String(x).trim())).filter(n => !isNaN(n));
    },
    /** 关闭动画结束后同步 visible，保证父组件的 v-model / .sync 生效 */
    handleClosed() {
      this.$emit('update:visible', false);
    },
    /** 提交：校验通过后把表单数据抛给父组件，再关闭弹窗 */
    handleSave() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return;
        this.$emit('save', { mode: this.isAdd ? 'add' : 'edit', form: { ...this.form }});
        this.innerVisible = false;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.fd-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.fd-ico {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background: #e8f7f0;
  color: #00a551;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.fd-title {
  display: flex;
  flex-direction: column;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.fd-title .fd-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}
.hint {
  font-size: 12px;
  color: #86909c;
  line-height: 1.5;
  margin-top: 4px;
}
.subs-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
::v-deep .subs-group .el-checkbox {
  margin-right: 0;
  display: flex;
  align-items: center;
}
::v-deep .subs-group .el-checkbox__label {
  padding-left: 6px;
  font-size: 12px;
}
.sub-pt {
  font-size: 12px;
  color: #86909c;
}
</style>
